export const SET_USER_LOGGED_IN = '@user/SET_USER_LOGGED_IN'

export function setUserLoggedIn(payload){
    return {type: SET_USER_LOGGED_IN, payload};
};